import React from "react";
import { Quote } from "lucide-react"; // Optional: install lucide-react for icons
import agarwal from "../../assets/images/VK_SIR/agarwal.jpg"
const ChairmanMessage = () => {
  return (
    <section className="relative w-full py-16 overflow-hidden bg-slate-50 md:py-28">
      {/* Decorative Background Element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-blue-50/50 -skew-x-12 transform translate-x-20" />

      <div className="container relative px-6 mx-auto max-w-7xl">
        <div className="flex flex-col items-center gap-12 lg:flex-row lg:items-start">
          
          {/* Image Container with Decorative Frame */}
          <div className="relative group">
            <div className="absolute -inset-4 border-2 border-orange-200/50 rounded-2xl -rotate-3 transition-transform group-hover:rotate-0" />
            <div className="relative overflow-hidden shadow-2xl rounded-2xl w-64 h-80 md:w-80 md:h-[450px] lg:w-[400px]">
              <img
                src={agarwal}
                alt="Dr. V.K. Agarwal"
                className="object-cover w-full h-full transition-scale duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent" />
            </div>
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 hidden md:flex flex-col bg-white p-4 shadow-xl rounded-lg border-l-4 border-orange-500">
              <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Founded By</span>
              <span className="text-sm font-bold text-slate-800">Visionary Leadership</span>
            </div>
          </div>

          {/* Content Side */}
          <div className="flex-1 mt-8 lg:mt-0">
            <div className="inline-flex items-center gap-2 px-3 py-1 mb-4 rounded-full bg-orange-100 text-orange-700">
              <span className="w-2 h-2 bg-orange-500 rounded-full animate-pulse" />
              <span className="text-xs font-bold uppercase tracking-wider">Leadership Note</span>
            </div>

            <h2 className="relative text-3xl font-black tracking-tight text-slate-900 md:text-5xl lg:text-6xl">
              Message from the <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-orange-400">
                Chairman
              </span>
            </h2>

            <div className="relative mt-8 group">
              <Quote className="absolute -top-6 -left-8 w-16 h-16 text-slate-200 -z-10 group-hover:text-orange-100 transition-colors" />
              
              <div className="space-y-6 text-lg leading-relaxed text-slate-600">
                <p className="first-letter:text-4xl first-letter:font-bold first-letter:text-slate-800 first-letter:mr-2">
                  In a world where cinema connects emotions and inspires millions, 
                  <span className="font-semibold text-slate-900"> Sunrising Cinevision</span> stands as a 
                  hub of creativity, learning, and professional production. Our vision is not only to 
                  educate but also to create real opportunities through hands-on industry experience.
                </p>

                <p>
                  With the expansion into both <span className="text-slate-900 font-medium">Academy</span> and 
                  <span className="text-slate-900 font-medium"> Production</span> divisions, we are committed 
                  to bridging the gap between learning and real-world execution. From training aspiring 
                  artists to producing high-quality films—we aim to build complete industry-ready professionals.
                </p>
                
                <p className="italic border-l-4 border-orange-500 pl-4 bg-orange-50/50 py-2">
                  "Our mission is to provide a platform where passion meets opportunity, 
                  and creativity turns into a successful career."
                </p>
              </div>

              <footer className="pt-8 mt-10 border-t border-slate-200">
                <div className="flex items-center gap-4">
                  <div className="h-1 w-12 bg-orange-500" />
                  <div>
                    <h4 className="text-xl font-bold text-slate-900">Dr. V.K. Agarwal</h4>
                    <p className="text-sm font-medium text-slate-500">MBBS, MD, MBA | Chairman</p>
                  </div>
                </div>
              </footer>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ChairmanMessage;